import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';
import { IfHasPermissionDirective } from '../../../../core/directives/if-has-permission/if-has-permission.directive';
import { DashboardQuickAction } from '../../../../core/models/ui/dashboard.model';

@Component({
	selector: 'ms-dashboard-quick-actions',
	imports: [RouterLink, FaDuotoneIconComponent, IfHasPermissionDirective],
	templateUrl: './dashboard-quick-actions.component.html',
	styleUrl: './dashboard-quick-actions.component.scss'
})
export class DashboardQuickActionsComponent {
	public actions = input.required<DashboardQuickAction[]>();
}
